import BaseProductVariant, { IBaseProductVariant } from './BaseProductVariant'
import ProductVariant from './ProductVariant'
import PRODUCT_VARIANT_DOMAIN_TYPES from './ProductVariantDomainTypes'

type IProductVariantLite = IBaseProductVariant

export default class ProductVariantLite extends BaseProductVariant implements IProductVariantLite {
  constructor(iProductVariantLite: IProductVariantLite) {
    super(iProductVariantLite, PRODUCT_VARIANT_DOMAIN_TYPES.PRODUCT_VARIANT_LITE)
    return {
      ...this,
    }
  }

  static fromProductVariant(productVariant: ProductVariant) {
    return new ProductVariantLite(productVariant)
  }
}
